import { GameState } from '../StateManager';
import { Game } from '../Game';
import { COLORS } from '../config/settings';

export class PauseState implements GameState {
  private game: Game;
  private animTimer: number = 0;

  constructor(game: Game) {
    this.game = game;
  }

  public enter(): void {
    console.log('Game Paused');
  }

  public exit(): void {
    console.log('Game Resumed');
  }

  public update(deltaTime: number): void {
    this.animTimer += deltaTime;

    const input = this.game.getInput();

    if (input.escape || input.enter) {
      // Resume game
      this.game.getStateManager().changeState('play');
    }
  }

  public render(ctx: CanvasRenderingContext2D): void {
    const renderer = this.game.getRenderer();
    
    // Darken background
    ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
    ctx.fillRect(0, 0, renderer.width, renderer.height);

    const centerX = renderer.width / 2;
    const centerY = renderer.height / 2;

    // Pause text with pulsing effect
    const pulse = 0.7 + Math.sin(this.animTimer * 3) * 0.3;
    ctx.globalAlpha = pulse;
    ctx.font = 'bold 48px "Courier New"';
    ctx.fillStyle = COLORS.ACCENT;
    ctx.textAlign = 'center';
    ctx.fillText('PAUSED', centerX, centerY);
    ctx.globalAlpha = 1;

    // Instructions
    ctx.font = '18px "Courier New"';
    ctx.fillStyle = COLORS.TEXT;
    ctx.fillText('Press ESC or ENTER to resume', centerX, centerY + 50);
  }
}
